module.exports = __webpack_public_path__ + "static/media/img_Benchmarking202.a3793c54.png";